<!--根据VideoEdit修改,测试-->
<template>
  <div>
    <div>
      <div class="flex-column w-full">
        <div class="flex-row w-full">
          <div class="video-style relative" style="height:255px;width: 100%">
            <div class="relative" style="width: 100%;height:255px; " v-show="getvideourl">
              <video :src="getvideourl" alt="" id="video-sid"
                     style="height:255px;object-fit: fill;width: 100%"/>
              <img :src="videoinfos.imgUrl" alt="" class="absolute top-0 left-0"
                   style="width: 100%;height:255px;" v-if="getvideourl && videoinfos.imgUrl">
              <img class="play-img-style" src="../../assets/common/ic_shipinbiaozhi_white@2x.png"
                   v-if="getvideourl && videoinfos.imgUrl">
            </div>
            <video-player :poster="videoinfos.imgUrl" :vid="videoinfos.videoAliVid"
                          aspectRatio="16:9"
                          ref="players"
                          style="width: 100%;height: 158px"
                          v-show="videoinfos.videoAliVid && !videoinfos.localUrl && !videoinfos.videoUrl"/>
            <div @click.stop="onButtomClick" class="absolute top-0 "
                 style="width: 100%;height: 255px;background-color: #00000040;cursor: pointer;"
                 v-if="videoinfos.localUrl ||videoinfos.videoUrl || videoinfos.videoAliVid "></div>
            <p @click="onDeleteVideo()" class="delete-style" style="top: -7px;right: -7px;"
               v-if="videoinfos.localUrl||videoinfos.videoUrl || videoinfos.videoAliVid"><span
              class="delete-inner"></span></p>
            <up-load-video :funcallback="onVideoUpload" :videoInfix="videoInfix"
                           :vidupload="vidupload"
                           @uploadSuccess="uploadVideoSuccess"
                           @uploadstart="uploadImageStart"
                           accept="video/*"
                           v-if="!videoinfos.localUrl&&!videoinfos.videoAliVid && !videoinfos.videoUrl">
              <div class="flex-column " slot="tip"
                   style="width: 100%;height: 255px;background-color: #F6F9FF;">
                <img alt="" src="../../assets/common/ic_upload_video@2x.png"
                     style="width: 64px;height: 64px">
                <div class="m-t-5  color-66">上传视频</div>
                <div class="fz-20 flex-column w-full"
                     style="height:255px;color: green;position: absolute;bottom: 0;background-color: #00000040;justify-content: flex-end"
                     v-if="process">
                  <div
                    style="width: 100%;height: 30px;line-height: 30px;text-align: center;background-color: #00000050">
                    上传进度{{ process }}
                  </div>
                </div>
              </div>
            </up-load-video>
          </div>
        </div>
      </div>
    </div>

    <Modal
      @on-visible-change="onVideoPrewModalClose"
      class-name="vertical-center-modal"
      footer-hide
      v-model="showVideoPrew"
      width="650">
      <video-prew :videoinfo="videoprewinfo" ref="prewplayer"/>
    </Modal>
  </div>
</template>

<script>
import VideoPlayer from './VideoPlayer'
import UpLoadVideo from './UpLoadVideo'
import UpLoadImage from './UpLoadImage'
import VideoPrew from './VideoPrew'

export default {
  name: 'VideoEditTest',
  components: {VideoPrew, UpLoadImage, UpLoadVideo, VideoPlayer},
  props: {
    picInfix: {
      type: String,
      default: ''
    },
    videoinfo: {
      type: Object
    },
    vidupload: {
      type: Boolean,
      default: true
    },
    coverEnable: {
      type: Boolean,
      default: true
    },
    videoInfix: {
      type: String,
      default: ''
    }
  },
  watch: {
    videoinfo: {
      handler (newValue, oldValue) {
        this.videoinfos = JSON.parse(JSON.stringify(newValue))
      },
      deep: true
    }
  },
  computed: {
    getvideourl () {
      if (this.videoinfos.localUrl) {
        return this.videoinfos.localUrl
      }
      if (this.videoinfos.videoUrl) {
        return this.videoinfos.videoUrl
      }
      return ''
    }
  },
  mounted () {
    if (this.videoinfo) {
      this.videoinfos = JSON.parse(JSON.stringify(this.videoinfo))
    }
  },
  data () {
    return {
      process: '',  //上传进度条
      videoinfos: {  //视频信息
        id: 0,            //这条视频在后台库的Id
        videoAliVid: '',  //阿里云路径
        localUrl: '',     //本地路径
        videoUrl: '',     //Oss视频路径
        videoTitle: '',   //视频标题
        imgUrl: '',       //视频封面
        videoTime: '',    //视频时长
        videoSize: '',    //视频大小
        videoDesc: '',    //视频描述
        width: 0,
        height: 0
      },
      showVideoPrew: false,  //控制预览
      videoprewinfo: {       //预览参数
        videoAliVid: '',
        videoUrl: '',
        coverUrl: '',
        videoTitle: ''
      }
    }
  },
  methods: {
    getVideoInfo () {
      let video = document.getElementById('video-sid')
      if (video && (this.videoinfos.localUrl || this.videoinfos.videoUrl)) {
        this.videoinfos.videoTime = video.duration
        this.videoinfos.width = video.videoWidth
        this.videoinfos.height = video.videoHeight
      }
      return this.videoinfos
    },
    onVideoPrewModalClose (status) {
      if (!status) {
        this.videoprewinfo = {
          videoUrl: '',
          videoAliVid: '',
          coverUrl: '',
          videoTitle: ''
        }
      }
    },
    onButtomClick () {
      // if (this.vidupload) {
      //   return
      // }
      let item = this.videoinfos
      if (item.videoUrl || item.videoAliVid) {
        this.videoprewinfo = {
          videoUrl: item.videoUrl || '',
          videoAliVid: item.videoAliVid || '',
          coverUrl: item.imgUrl,
          videoTitle: item.videoTitle
        }
        this.showVideoPrew = true
      }
    },
    onVideoUpload (data) {
      this.process = Number.parseInt(data * 100) + '%'
    },
    onItemDelCk () {
      this.videoinfos.imgUrl = ''
    },
    uploaSuccess (data) {
      if (data && data.length) {
        this.videoinfos.imgUrl = data[0].url
      }
    },

    onDeleteVideo () {
      this.videoinfos = {
        videoAliVid: '',
        videoUrl: '',
        localUrl: '',
        videoTitle: '',
        imgUrl: '',
        videoTime: '',
        videoSize: '',
        videoDesc: '',
      }
    },
    onConfigCancelClick () {
      if (this.process) {
        return this.$Message.info('请等待视频上传完成')
      }
      this.$emit('onConfigCancelClick')
    },
    onConfigClick () {
      if (this.process) {
        return this.$Message.info('请等待视频上传完成')
      }
      if (this.coverEnable) {
        if (this.videoinfos.videoAliVid && !this.videoinfos.imgUrl) {
          return this.$Message.info('请上传视频封面')
        }
      }
      let videoinfos = this.videoinfos
      let video = document.getElementById('video-sid')
      if (video && (this.videoinfos.localUrl || this.videoinfos.videoUrl)) {
        this.videoinfos.videoTime = video.duration
      }
      this.$emit('configvideoclick', videoinfos)
    },
    uploadVideoSuccess (data) {
      this.videoinfos.videoAliVid = data[0].videoId
      this.videoinfos.localUrl = data[0].localUrl
      this.videoinfos.videoUrl = data[0].videoUrl
      this.videoinfos.videoSize = data[0].localfile.size
      if (!this.videoinfos.videoTitle) {
        this.videoinfos.videoTitle = this.getTitleByFiles(data[0].localfile)
      }
      this.process = ''
    },
    getTitleByFiles (localfile) {
      let filename = ''
      if (localfile && localfile.name) {
        filename = localfile.name.split('.')[0]
      }
      return filename
    },
    uploadImageStart () {
    },
  }
}
</script>

<style lang="scss" scoped>
  .page-style {
    margin: 15px 0;
    text-align: right;
  }

  .video-style ::v-deep .video-js .vjs-big-play-button {
    /*
     播放按钮换成圆形
    */
    font-size: 2em;
    border-radius: 1em;
  }

  .video-style ::v-deep .vjs-control-bar {
    display: none;
  }

  div ::v-deep .ivu-input {
    font-size: 14px;
    color: blue;
  }

  .play-img-style {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
